import type { ReactElement, SVGProps } from "react";

export function SkillsPageFolderIcon({
  open,
  ...props
}: SVGProps<SVGSVGElement> & { open?: boolean }): ReactElement {
  return open ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M14 6V4C14 3.44772 13.5523 3 13 3H7.5L6 1.5H3C2.44772 1.5 2 1.94772 2 2.5V13.5C2 14.0523 2.44772 14.5 3 14.5H4L6 7H15L14 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7L4 14.5H13C13.4 14.5 13.75 14.2 13.85 13.8L15 7H6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M14 13.5H2C1.44772 13.5 1 13.0523 1 12.5V3.5C1 2.94772 1.44772 2.5 2 2.5H6L7.5 4.5H14C14.5523 4.5 15 4.94772 15 5.5V12.5C15 13.0523 14.5523 13.5 14 13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
